/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RegisterModerationActivity
// ====================================================

export interface RegisterModerationActivity {
  success: boolean | null;
}

export interface RegisterModerationActivityVariables {
  input: ModerationActivityInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ApproveModerationOptions
// ====================================================

export interface ApproveModerationOptions {
  success: boolean | null;
}

export interface ApproveModerationOptionsVariables {
  input: ApproveModerationOptionsInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ModerateOptions
// ====================================================

export interface ModerateOptions {
  success: boolean | null;
}

export interface ModerateOptionsVariables {
  input: ModerateOptionsInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResolveModerationOption
// ====================================================

export interface ResolveModerationOption {
  success: boolean | null;
}

export interface ResolveModerationOptionVariables {
  input: ResolveModerationOptionInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: OptionPendingModeration
// ====================================================

export interface OptionPendingModeration_option_product {
  id: string;
  sourceName: string | null;
  sourceUrl: string | null;
}

export interface OptionPendingModeration_option_entities {
  id: string;
  entity: string;
  value: string;
}

export interface OptionPendingModeration_option_aliexpressPullingImages {
  id: string;
  imageUrl: string;
  parentImageId: string | null;
  optionValue: string | null;
}

export interface OptionPendingModeration_option {
  id: string;
  product: OptionPendingModeration_option_product;
  entities: OptionPendingModeration_option_entities[];
  aliexpressPullingImages: OptionPendingModeration_option_aliexpressPullingImages[] | null;
}

export interface OptionPendingModeration {
  option: OptionPendingModeration_option | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: OptionsPendingApproval
// ====================================================

export interface OptionsPendingApproval_moderationOptions_image {
  id: string | null;
  nesImageId: string | null;
  status: string | null;
  originalUrl: string;
  imageUrl: string;
}

export interface OptionsPendingApproval_moderationOptions {
  id: string;
  resolveAction: ModerationOptionResolveAction | null;
  hasBackground: boolean | null;
  containsLogo: boolean | null;
  image: OptionsPendingApproval_moderationOptions_image | null;
}

export interface OptionsPendingApproval {
  moderationOptions: OptionsPendingApproval_moderationOptions[] | null;
}

export interface OptionsPendingApprovalVariables {
  count: number;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: OptionsPendingModeration
// ====================================================

export interface OptionsPendingModeration_options_product_images {
  id: string;
  sourceUrl: string;
  deletedAt: any | null;
}

export interface OptionsPendingModeration_options_product {
  id: string;
  sourceName: string | null;
  sourceUrl: string | null;
  images: OptionsPendingModeration_options_product_images[];
}

export interface OptionsPendingModeration_options_image {
  id: string;
  sourceUrl: string;
  deletedAt: any | null;
}

export interface OptionsPendingModeration_options {
  id: string;
  product: OptionsPendingModeration_options_product;
  image: OptionsPendingModeration_options_image | null;
}

export interface OptionsPendingModeration {
  options: OptionsPendingModeration_options[] | null;
}

export interface OptionsPendingModerationVariables {
  count: number;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: OptionsPendingRemoderation
// ====================================================

export interface OptionsPendingRemoderation_moderationOptions_option_entities {
  entity: string;
  value: string;
}

export interface OptionsPendingRemoderation_moderationOptions_option_product_images_nextImage {
  id: string | null;
  nesImageId: string | null;
  imageUrl: string;
  originalUrl: string;
  status: string | null;
}

export interface OptionsPendingRemoderation_moderationOptions_option_product_images {
  id: string;
  sourceUrl: string;
  deletedAt: any | null;
  nextImage: OptionsPendingRemoderation_moderationOptions_option_product_images_nextImage | null;
}

export interface OptionsPendingRemoderation_moderationOptions_option_product {
  id: string;
  sourceName: string | null;
  sourceUrl: string | null;
  images: OptionsPendingRemoderation_moderationOptions_option_product_images[];
}

export interface OptionsPendingRemoderation_moderationOptions_option {
  id: string;
  entities: OptionsPendingRemoderation_moderationOptions_option_entities[];
  product: OptionsPendingRemoderation_moderationOptions_option_product;
}

export interface OptionsPendingRemoderation_moderationOptions_image {
  id: string | null;
  nesImageId: string | null;
  status: string | null;
  url: string;
}

export interface OptionsPendingRemoderation_moderationOptions {
  id: string;
  status: ModerationOptionStatus | null;
  resolveAction: ModerationOptionResolveAction | null;
  imageBroken: boolean | null;
  hasBackground: boolean | null;
  containsLogo: boolean | null;
  containsText: boolean | null;
  logoCoversProduct: boolean | null;
  option: OptionsPendingRemoderation_moderationOptions_option;
  image: OptionsPendingRemoderation_moderationOptions_image | null;
}

export interface OptionsPendingRemoderation {
  moderationOptions: OptionsPendingRemoderation_moderationOptions[] | null;
}

export interface OptionsPendingRemoderationVariables {
  count: number;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ImageFragment
// ====================================================

export interface ImageFragment {
  id: string;
  sourceUrl: string;
  deletedAt: any | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RemoderationImageFragment
// ====================================================

export interface RemoderationImageFragment_nextImage {
  id: string | null;
  nesImageId: string | null;
  imageUrl: string;
  originalUrl: string;
  status: string | null;
}

export interface RemoderationImageFragment {
  id: string;
  sourceUrl: string;
  deletedAt: any | null;
  nextImage: RemoderationImageFragment_nextImage | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ModerationOptionResolveAction {
  DELETE = "DELETE",
  NONE = "NONE",
  REPLACE = "REPLACE",
  UPDATE = "UPDATE",
}

export enum ModerationOptionStatus {
  CLAIMED = "CLAIMED",
  FIXED = "FIXED",
  FIXING = "FIXING",
  PENDING = "PENDING",
  PENDING_SCREENING = "PENDING_SCREENING",
  SCREENED = "SCREENED",
}

export interface ApproveModerationOptionsInput {
  approveModerationOptionIds?: (string | null)[] | null;
  rejectModerationOptionIds?: (string | null)[] | null;
}

export interface ModerateOptionsInput {
  options: ModerationOptionInput[];
}

export interface ModerationActivityInput {
  action?: string | null;
  optionId?: string | null;
  userSlug?: string | null;
}

export interface ModerationOptionInput {
  containsLogo?: boolean | null;
  containsText?: boolean | null;
  hasBackground?: boolean | null;
  imageBroken?: boolean | null;
  logoCoversProduct?: boolean | null;
  nesOptionId?: string | null;
  status?: ModerationOptionStatus | null;
}

export interface ResolveModerationOptionInput {
  file?: any | null;
  id?: string | null;
  imageId?: string | null;
  resolveAction?: ModerationOptionResolveAction | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================



// WEBPACK FOOTER //
// ./src/graphql/types.ts